import { apiService } from '@/services/APIService';

export default {

  getDirectoryDocuments(params) {
    return apiService.get('/directory-documents', params);
  },

  createDirectoryDocument(params) {
    return apiService.post('/directory-documents', params);
  },

  updateDirectoryDocument(id, params) {
    return apiService.put(`/directory-documents/${id}`, params);
  },

  deleteDirectoryDocument(id) {
    return apiService.delete(`/directory-documents/${id}`);
  },

  // EVENT directory documents

  getEventDirectoryDocuments(id, params) {
    return apiService.get(`/event-directory-documents/${id}`, params);
  },

  addEventDirectoryDocuments(id, params) {
    return apiService.post(`/event-directory-documents/${id}/add`, params);
  },

  removeEventDirectoryDocuments(id, params) {
    return apiService.delete(`/event-directory-documents/${id}/remove`, { params });
  },

  changeWeightEventDirectoryDocuments(id, document_id, params) {
    return apiService.put(`/event-directory-documents/${id}/weight/${document_id}`, params);
  },

  getEventDirectoryDocumentsOptions(params) {
    return apiService.get('/event-directory-document-options', params);
  },

  createEventDirectoryDocuments(params) {
    return apiService.post('/event-directory-document-options', params);
  },

  updateEventDirectoryDocuments(id, params) {
    return apiService.put(`/event-directory-document-options/${id}`, params);
  },

  deleteEventDirectoryDocuments(id) {
    return apiService.delete(`/event-directory-document-options/${id}`);
  },

};
